<template>
  <v-row
    dense
    justify="center"
    align="center"
    v-if="this.$store.state.store.store"
  >
    <v-col cols="12" sm="12">
      <v-expansion-panels outlined v-model="panel_open">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="primary"> $expand </v-icon>
            </template>
            <template v-slot:default="{ open }">
              <v-row no-gutters align="center">
                <v-col cols="8">
                  <v-row dense no-gutters align="center">
                    <v-col cols="auto">
                      <v-btn small icon class="pa-0 ma-0 mr-2" color="black">
                        <v-icon> mdi-google-analytics </v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="9">
                      <strong>
                        {{ $t("messanger.dash.matomo_state.name") }}
                      </strong>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">
                      {{ $t("messanger.dash.matomo_state.select_choise") }}
                    </span>
                    <span v-else key="1">
                      {{ ex1 ? $t(`messanger.dash.matomo_state.${ex1}`) : "" }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group v-model="ex1" columns mandatory light>
              <v-row dense justify="center" align="center">
                <v-col cols="auto">
                  <v-radio
                    :label="$t('messanger.dash.matomo_state.enable')"
                    color="#1141ce"
                    value="enable"
                    class="px-3"
                    @click="status_box"
                  ></v-radio>
                </v-col>
                <v-col cols="auto">
                  <v-radio
                    :label="$t('messanger.dash.matomo_state.disable')"
                    color="#1141ce"
                    value="disable"
                    class="px-3"
                    @click="status_box"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "boxStatus",
  data: () => ({
    ex1: "",
    panel_open: false,
  }),
  computed: {
    matomo_state() {
      return this.$store.state.store_config.store.details.matomo_activated;
    },
  },
  async mounted() {
    await this.$store.dispatch("FETCH_STORE");
    this.ex1 = this.matomo_state ? "enable" : "disable";
  },
  methods: {
    status_box() {
      const enable = this.ex1 === "enable" ? true : false;
      this.$store
        .dispatch("CHANGE_MATOMO_ENABLE_STATE", { matomo_activated: enable })
        .then((r) => {
          this.$store.dispatch("setSnackbar", {
            text: `${this.$t("messanger.dash.matomo_state.name")} "${
              this.ex1
            }"`,
            color: "success",
            timeout: 3000,
          });
          this.panel_open = false;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.filters-icons .v-responsive__content {
  width: 26px !important;
}
</style>
